import { Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { warningTextColor } from "./warning-text-color"

/**
 * Separates what is being viewed (a regime, only a lens for browsing) from what is being
 * edited (the skill map), since assignments apply to every regime costed with the map.
 */
export function AssignmentScopeNote({ regimeLabel, skillMapName }) {
    const viewing = regimeLabel || "choose a regime to browse"
    const editing = skillMapName || "this skill map"

    return (
        <Stack spacing={0} sx={{ minWidth: 0 }} data-cy="assignment-scope-note">
            <Typography variant="body2">
                <Typography component="span" variant="body2" color="text.secondary">
                    Viewing schedules from:{" "}
                </Typography>
                <strong>{viewing}</strong>
            </Typography>
            <Typography variant="body2">
                <Typography component="span" variant="body2" color="text.secondary">
                    Editing assignments on:{" "}
                </Typography>
                <strong>{editing}</strong>
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ color: warningTextColor }}>
                <Iconify icon="eva:info-outline" width={16} />
                <Typography variant="caption">These assignments apply to every regime using this skill map.</Typography>
            </Stack>
        </Stack>
    )
}
